// Przestrzeń nazw 'agents': ukryta sekcja „agenci AI" (lista, tworzenie, szczegóły agenta).
//
// VERIFY: cały plik, brak w mockupie. Sekcja jest ukryta w menu, więc mockup jej nie zna i całość
// to tłumaczenie własne. Słowa z mockupu, które tu wpadły (np. „Aktywny", „Baza wiedzy"),
// są zgodne z jego słownictwem. Terminy niepewne mają dodatkowy komentarz VERIFY.
//
// Kontrakty z API zostają po angielsku (wartości `publish_status`, `budget_action`, modele,
// kody języków). Tłumaczy się tylko etykiety, klucze mapują się po wartości enuma.
export default {
  createAgent: 'Utwórz agenta AI',

  // Etykiety pól formularza i nagłówki kolumn współdzielone przez listę, tworzenie i szczegóły.
  labels: {
    name: 'Nazwa',
    systemPrompt: 'Prompt systemowy',
    firstMessage: 'Pierwsza wiadomość',
    language: 'Język',
    voice: 'Głos',
    phoneNumber: 'Numer telefonu',
    status: 'Status',
    monthlyBudget: 'Miesięczny budżet (minuty)',
    budgetAlertThreshold: 'Próg alertu budżetu (%)',
    // VERIFY: „Budget Action" to reakcja na budżet (alert albo automatyczne cofnięcie publikacji).
    budgetAction: 'Działanie po przekroczeniu budżetu',
  },
  placeholders: {
    name: 'Nazwa agenta',
    systemPrompt: 'Instrukcje opisujące, jak agent ma się zachowywać…',
    firstMessage: 'Pierwsza wiadomość, którą agent wypowiada po odebraniu rozmowy…',
    phoneNumber: 'Wybierz numer telefonu',
    noLimit: 'Bez limitu',
  },
  validation: {
    nameRequired: 'Podaj nazwę agenta',
  },
  // Klucze to wartości `budget_action` z API.
  budgetActions: {
    alert: 'Tylko alert',
    autoUnpublish: 'Automatyczne cofnięcie publikacji',
  },
  // Klucze to wartości `publish_status` z API. Ta sama mapa etykietuje też statusy
  // dokumentów bazy wiedzy (`KB_STATUS_MAP` w agent-detail).
  publishStatus: {
    draft: 'Wersja robocza',
    saving_agent: 'Zapisywanie agenta',
    agent_saved: 'Agent zapisany',
    kb_processing: 'Przetwarzanie bazy wiedzy',
    ready_to_publish: 'Gotowy do publikacji',
    publishing: 'Publikowanie',
    published: 'Opublikowany',
    publish_failed: 'Błąd publikacji',
    budget_exceeded: 'Przekroczony budżet',
  },
  // Klucze to kody języków z API (wartość `language` agenta).
  languageOptions: {
    en: 'Angielski',
    es: 'Hiszpański',
    fr: 'Francuski',
    de: 'Niemiecki',
    pt: 'Portugalski',
    zh: 'Chiński',
    ja: 'Japoński',
    ko: 'Koreański',
    ar: 'Arabski',
    hi: 'Hindi',
  },
  // Klucze to wartości `eleven_labs_model` z API.
  models: {
    eleven_flash_v2_5: 'Flash V2.5 (najszybszy, niższa jakość)',
    eleven_turbo_v2: 'Turbo V2',
    eleven_turbo_v2_5: 'Turbo V2.5',
    eleven_multilingual_v2: 'Multilingual V2 (wolniejszy, najlepszy dla języków innych niż angielski)',
  },

  list: {
    columns: {
      knowledgeBase: 'Baza wiedzy',
      createdAt: 'Utworzono',
    },
    view: 'Zobacz',
    tags: {
      active: 'Aktywny',
      multilingual: 'Wielojęzyczny',
    },
    selectCompany: 'Wybierz firmę',
  },

  create: {
    prefill: {
      title: 'Uzupełniono na podstawie dotychczasowej konfiguracji RAI',
      description:
        'Nazwa agenta, prompt systemowy i pierwsza wiadomość zostały uzupełnione na podstawie bieżących ustawień firmy. Można je edytować przed utworzeniem agenta.',
    },
  },

  detail: {
    notFound: 'Nie znaleziono agenta.',
    // VERIFY: „tryb wielojęzyczny" jako nazwa przełącznika `multilingual` (w liście: tag „Wielojęzyczny").
    multilingualMode: 'Tryb wielojęzyczny',
    tabs: {
      config: 'Konfiguracja',
      knowledgeBase: 'Baza wiedzy ({{total}})',
      languages: 'Języki',
      languagesWithCount: 'Języki ({{total}})',
      integration: 'Integracja',
      usage: 'Wykorzystanie',
      // VERIFY: „połączenie testowe", bo agent dzwoni na podany numer telefonu (linia, nie rozmowa).
      testCall: 'Połączenie testowe',
      audioClips: 'Klipy audio ({{ready}}/{{total}})',
    },
    header: {
      sync: 'Synchronizuj z ElevenLabs',
      unpublish: 'Cofnij publikację',
      publish: 'Opublikuj',
      publishError: 'Błąd publikacji: {{error}}',
    },
    messages: {
      updated: 'Zaktualizowano agenta',
      deleted: 'Usunięto agenta',
      publishStarted: 'Rozpoczęto publikację agenta',
      publishFailed: 'Nie udało się opublikować agenta',
      unpublished: 'Cofnięto publikację agenta',
      unpublishFailed: 'Nie udało się cofnąć publikacji agenta',
      synced: 'Zsynchronizowano agenta z ElevenLabs',
      syncFailed: 'Synchronizacja nie powiodła się',
    },
    delete: {
      title: 'Usuń agenta AI',
      content: 'Czy na pewno usunąć tego agenta? Tej operacji nie można cofnąć.',
    },

    config: {
      // VERIFY: „bridge" (translation bridge) = most tłumaczeniowy na żywo między mieszkańcem
      // a urzędnikiem; tak samo w opisie silnika TTS i w tekście o klipach wypełniających.
      voiceNotFound:
        'Skonfigurowany głos nie został znaleziony w przestrzeni roboczej ElevenLabs. Most tłumaczeniowy użyje domyślnego głosu dla tego języka, dopóki nie zostanie wybrany inny.',
      engine: {
        label: 'Silnik TTS (most tłumaczeniowy)',
        tooltip:
          'Silnik syntezy mowy ElevenLabs używany w moście tłumaczeniowym na żywo, gdy urzędnik przejmie rozmowę. Multilingual V2 daje wyraźnie czystszy dźwięk w językach innych niż angielski, kosztem opóźnienia większego o ok. 250–400 ms. Pozostaw puste, aby użyć ustawienia domyślnego firmy.',
        placeholder: 'Użyj ustawienia domyślnego firmy',
      },
      stt: {
        title: 'Ustawienia rozpoznawania mowy (STT)',
        vadThreshold: 'Próg VAD',
        vadTooltip:
          'Czułość wykrywania aktywności głosowej (0,0–1,0). Wyższa wartość = mniej szumu tła, ale ciche wypowiedzi mogą zostać pominięte.',
        minSpeechDuration: 'Min. czas wypowiedzi (ms)',
        minSpeechTooltip:
          'Minimalny czas trwania wypowiedzi w milisekundach, po którym trafia ona do transkrypcji. Wyższa wartość = mniej fałszywych trafień wywołanych szumem.',
      },
      saveChanges: 'Zapisz zmiany',
    },

    kb: {
      type: 'Typ',
      // Etykiety źródła dokumentu (`source_type`), używane w kolumnie „Typ" i w przełączniku dodawania.
      sourceTypes: {
        text: 'Tekst',
        url: 'URL',
        file: 'Plik',
      },
      viewContent: 'Zobacz treść',
      checkIndexed: 'Sprawdź, czy zaindeksowano w ElevenLabs',
      statusChecked: 'Sprawdzono status',
      statusCheckFailed: 'Nie udało się sprawdzić statusu',
      removed: 'Usunięto dokument',
      removeFailed: 'Nie udało się usunąć dokumentu',
      // VERIFY: „transfer" z kodu oddany jako „import" (nagłówek sekcji mówi „Import from Company
      // Knowledge Base"), bo dokumenty są kopiowane z bazy wiedzy firmy do agenta.
      import: {
        title: 'Importuj z bazy wiedzy firmy (dostępne: {{total}})',
        selected: 'Importuj zaznaczone ({{total}})',
        all: 'Importuj wszystkie',
        imported_one: 'Zaimportowano {{count}} dokument',
        imported_few: 'Zaimportowano {{count}} dokumenty',
        imported_many: 'Zaimportowano {{count}} dokumentów',
        imported_other: 'Zaimportowano {{count}} dokumentu',
        failed: 'Nie udało się zaimportować dokumentów',
      },
      addDocument: 'Dodaj dokument',
      documentName: 'Nazwa dokumentu',
      content: 'Treść',
      contentPlaceholder: 'Wklej treść tekstową…',
      contentRequired: 'Podaj treść',
      urlRequired: 'Podaj adres URL',
      uploadFile: 'Prześlij plik',
      uploadingDocument: 'Przesyłanie dokumentu, to może chwilę potrwać…',
      uploadingFile: 'Przesyłanie pliku, to może chwilę potrwać…',
      textAdded: 'Dodano dokument tekstowy',
      urlAdded: 'Dodano dokument z adresu URL',
      fileUploaded: 'Przesłano plik',
    },

    usage: {
      used: '{{used}} / {{budget}} min wykorzystano',
      empty: 'Brak danych o wykorzystaniu.',
      columns: {
        date: 'Data',
        minutes: 'Minuty',
        calls: 'Rozmowy',
      },
    },

    testCall: {
      start: 'Wykonaj połączenie testowe',
      phoneRequired: 'Podaj numer telefonu',
      started: 'Zainicjowano połączenie testowe',
      failed: 'Nie udało się zainicjować połączenia testowego',
    },

    languages: {
      ttsEngine: 'Silnik TTS:',
      companyDefaultEngine: 'Ustawienie domyślne firmy (w danych uwierzytelniających firmy w CRM)',
      // VERIFY: oryginał mówił „General tab", ale zakładka nazywa się „Configuration" (Konfiguracja).
      changeInConfig: 'Zmień w zakładce Konfiguracja',
      multilingualDescription: '– automatycznie wykrywa język mieszkańca i odpowiada w tym języku',
      assignVoices:
        'Przypisz głos do każdego języka. Gdy agent wykryje język mieszkańca, automatycznie przełączy się na skonfigurowany głos. Używane są tylko włączone języki z przypisanym głosem.',
      // VERIFY: „workspace" = przestrzeń robocza ElevenLabs.
      workspaceVoices_one: 'W przestrzeni roboczej jest obecnie {{count}} głos.',
      workspaceVoices_few: 'W przestrzeni roboczej są obecnie {{count}} głosy.',
      workspaceVoices_many: 'W przestrzeni roboczej jest obecnie {{count}} głosów.',
      workspaceVoices_other: 'W przestrzeni roboczej jest obecnie {{count}} głosu.',
      healthUnavailable: 'Sprawdzenie stanu niedostępne – zobacz poniżej.',
      enabled: 'Włączony',
      notInWorkspace: 'Brak w przestrzeni roboczej',
      healthUnknown: 'Stan nieznany',
      save: 'Zapisz języki',
      saved: 'Zapisano ustawienia języków',
      multilingualEnabled: 'Włączono tryb wielojęzyczny',
      multilingualDisabled: 'Wyłączono tryb wielojęzyczny',
    },

    integration: {
      title: 'Integracja z ElevenLabs',
      columns: {
        setting: 'Ustawienie',
        value: 'Wartość',
      },
      rows: {
        agentId: 'ID agenta ElevenLabs',
        postCallWebhook: 'Webhook po rozmowie',
        webhookSecret: 'Sekret HMAC webhooka',
        initiationWebhook: 'Webhook inicjujący',
        monitoring: 'Monitoring na żywo',
      },
      values: {
        notPublished: 'Nie opublikowano',
        notConfigured: 'Nie skonfigurowano',
        secretSet: 'Ustawiono',
        secretNotSet: 'Nie ustawiono',
        initiationMissingHost: 'Nie skonfigurowano (brak APP_HOST)',
        monitoringOn: 'Włączony (zawsze aktywny)',
        multilingualOn: 'Włączony (języki z przypisanym głosem: {{languages}})',
        disabled: 'Wyłączony',
      },
      status: {
        ok: 'OK',
        missing: 'Brak – nie skonfigurowano',
        notApplicable: 'Nie dotyczy',
      },
      footer:
        'Te ustawienia są zarządzane automatycznie przez system. Publikacja lub synchronizacja agenta wysyła do ElevenLabs pełną konfigurację (monitoring, webhooki, ustawienia językowe, uprawnienia nadpisywania). Aby wysłać bieżącą konfigurację, użyj przycisku „{{syncButton}}" powyżej.',
    },

    audio: {
      title: 'Komunikaty dla mieszkańca',
      // <strong> = nazwa przycisku „Wygeneruj wszystkie ponownie" (wartość wstawiana z kodu).
      intro:
        'Dwa klipy są odtwarzane mieszkańcowi przy przekazaniu rozmowy z AI do urzędnika, w kolejności pokazanej poniżej. Edytuj tekst angielski, a następnie kliknij <strong>{{regenerateAll}}</strong> poniżej, aby nagrać klipy ponownie dla każdego głosu i języka. Wersje w innych językach są tłumaczone automatycznie z tekstu angielskiego w momencie generowania.',
      // Klucze to `clip_type` z API. `name` to krótka nazwa (tag w tabeli, komunikaty),
      // `label` to nagłówek edytora tekstu.
      clips: {
        // VERIFY: „Disclaimer" = zastrzeżenie (uprzedzenie mieszkańca, że rozmowa jest tłumaczona).
        disclaimer: {
          name: '1. Zastrzeżenie',
          label: '1. Zastrzeżenie (odtwarzane jako pierwsze)',
          description: 'Uprzedzenie, aby mieszkaniec wiedział, że rozmowa będzie tłumaczona na żywo.',
        },
        transferring: {
          name: '2. Przełączanie',
          label: '2. Przełączanie (odtwarzane jako drugie)',
          description:
            'Komunikat typu „przełączam rozmowę", który maskuje moment odłączenia agenta AI.',
        },
        // VERIFY: „Filler" = wypełniacz (krótki klip wypełniający ciszę w trakcie tłumaczenia).
        filler: {
          name: '3. Wypełniacz',
          label: '3. Wypełniacz (odtwarzany w trakcie tłumaczenia)',
          description:
            'Słyszalny między wypowiedziami, gdy LLM tłumaczy. Tekst powinien być krótki – odtwarza się przy każdej wypowiedzi w każdej rozmowie.',
        },
      },
      tags: {
        customized: 'Dostosowany',
        default: 'Domyślny',
        stale: 'Tekst zmieniony – klipy nieaktualne',
      },
      saveText: 'Zapisz tekst',
      resetToDefault: 'Przywróć domyślny',
      defaultText: 'Domyślny: „{{text}}"',
      textSaved:
        'Zapisano tekst: {{name}}. Kliknij „{{regenerateAll}}", aby nagrać klipy od nowa.',
      textReset:
        'Przywrócono domyślny tekst: {{name}}. Kliknij „{{regenerateAll}}", aby nagrać klipy od nowa.',
      // <strong> = nazwa przycisku „Wygeneruj wszystkie ponownie";   daje oddech wokół pogrubienia.
      staleNotice:
        'Co najmniej jeden tekst został zmieniony, ale nagrane audio jest nadal w starej wersji. Kliknij <strong> {{regenerateAll}} </strong>, aby nagrać ponownie.',
      generateMissing: 'Wygeneruj brakujące',
      regenerateAll: 'Wygeneruj wszystkie ponownie',
      refreshStatus: 'Odśwież status',
      generating: 'Generowanie komunikatów i klipów wypełniających… Status wkrótce się odświeży.',
      clip: 'Klip',
      noVoice: 'Nie skonfigurowano głosu',
      // Klucze to `source` z API (`none` = brak wartości).
      sources: {
        company: 'firma',
        default: 'domyślny',
        none: 'brak',
      },
      clipStatus: {
        ready: 'Gotowy',
        missing: 'Brak',
        missingWithReason: 'Brak – {{reason}}',
      },
      fillerTitle: 'Klipy wypełniające',
      // <strong> = nazwy przycisków „Wygeneruj brakujące" i „Wygeneruj wszystkie ponownie".
      fillerIntro:
        'Zlokalizowany klip odtwarzany stronie, która właśnie skończyła mówić, gdy most tłumaczeniowy transkrybuje i tłumaczy wypowiedź – wypełnia ciszę między końcem wypowiedzi a nadejściem tłumaczenia. Odtwarzany raz na wypowiedź (wiele razy w trakcie rozmowy). Generowany tymi samymi przyciskami <strong>{{generateMissing}}</strong> / <strong>{{regenerateAll}}</strong> powyżej – korzystają z tej samej pary (głos, język) co komunikaty.',
      previewPlay: 'Odtwórz podgląd',
      previewStop: 'Zatrzymaj podgląd',
    },
  },
} as const;
